import { Component, DestroyRef, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { Project } from 'src/app/shared/models/project';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { SelectedProjectApiService } from 'src/app/shared/components/selected-project/selected-project.api.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OrderByPipe } from 'src/app/shared/pipes/order-by.pipe';
import { Constants } from 'src/app/shared/utils/constants';

@Component({
  selector: 'app-esa-copy-project-dialog',
  templateUrl: './esa-copy-project-dialog.component.html',
  styleUrls: ['./esa-copy-project-dialog.component.css']
})

export class ESACopyProjectDialogComponent implements OnInit {

  @Output() onClickSaveButtonEvent = new EventEmitter<any>();

  visible: boolean = false;
  loading: boolean = false;
  selectedProjectCopy?: Project;
  filteredProjectsCopy: Project[] = [];
  projectsCopy: Project[] = [];
  destroyRef = inject(DestroyRef);
  myProjectsFilter: boolean = false;
  createdBy: string = '';
  projectPk?: number;
  rowData: any[] = [];
  originalRowData: any[] = [];
  rowHeight: number = 45;
  public columnDefs: any[] = [];
  public blockUi: boolean = false;
  public disableButton: boolean = false;
  isLoading!: boolean;
  dialogStyle: object = { width: '400px', height: '300px' }

  constructor(public projectApiService: SelectedProjectApiService, private orderByPipe: OrderByPipe) { }

  ngOnInit() { }

  async GetProject(): Promise<void> {
    this.projectApiService.projects
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((projects: Project[]) => {
        this.projectsCopy = projects;
        this.projectsFilter(false);
      });

    await this.projectApiService.getProjects('NA');
    this.loading = false;
  }

  async projectsFilter(state: boolean): Promise<void> {
    this.myProjectsFilter = state;
    this.filteredProjectsCopy = this.myProjectsFilter
      ? this.orderByPipe.transform([...this.projectsCopy.filter((p: Project) => p.createdBy === this.createdBy)], 'name')
      : this.orderByPipe.transform([...this.projectsCopy], 'name');
    this.filteredProjectsCopy = this.filteredProjectsCopy.filter((project: Project) => project.source?.toUpperCase() === Constants.FEATURE_ACRONYM.ESA_ASSESSMENT_UDL);
  }

  showDialog(visiblePopUp: boolean, projectPk?: number) {
    this.visible = visiblePopUp;
    this.projectPk = projectPk;
    this.GetProject();
  }

  onSelectionChanged({ originalEvent, value }: DropdownChangeEvent) {
    if (originalEvent && value) {
      this.selectedProjectCopy = value;
      return;
    }
    this.selectedProjectCopy = undefined;
  }

  closeDialog() {
    if (this.selectedProjectCopy?.projectPk != undefined) {
      this.onClickSaveButtonEvent.emit({ projectPkCopy: this.selectedProjectCopy?.projectPk });
      this.visible = false;
      this.selectedProjectCopy=undefined;
    }
  }

  close()
  {
    this.selectedProjectCopy=undefined;
  }
}
